import './apple.css'
import {  FcGoogle} from "react-icons/fc";
import { GoogleLogin } from '../config/firebase';

function Googlelogin(){
    return(
        <div className="cont" onClick={GoogleLogin}>
            {/* <> */}
            <FcGoogle style={{width:'10%',height:'22px'}}  />
             
             <p className='cont-text'>Continue with Google</p>
            {/* </> */}
        </div>
    )
}
export default Googlelogin;